import { Checkbox, Stack } from "office-ui-fabric-react";
import React, { useEffect, useRef, useState } from "react";
import { unstable_batchedUpdates } from "react-dom";
import styled from "styled-components";
import { theme } from "theme";
import { IPagination } from "views/pages/Journal/NewJournals/JournalFunc";

const ItemsContainer = styled.div`
  max-height: 300px;
  overflow-y: auto;
  position: relative;
`;

interface IProps {
  filtersList: {
    key: any;
    value: any;
    data: {
      id: any;
      name: any;
    }
  }[];
  searchValue: string;
  isAllSelected: boolean;
  selectedValues: any[];
  onElementChecked: any;
  onLoadMore: (limit: number, offset: number) => void;
  canLoadMore: boolean;
};

const FiltersList = ({ filtersList, searchValue, isAllSelected, selectedValues, onElementChecked, onLoadMore, canLoadMore }: IProps) => {
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [pagination, setPagination] = useState<IPagination>({
    limit: 100,
    offset: 0,
  });
  const filtersRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    const handleScroll = () => {
      if (!filtersRef.current) return;

      const { scrollTop, scrollHeight, clientHeight } = filtersRef.current;

      if (scrollTop + clientHeight >= scrollHeight && !isFetching) {
        canLoadMore && unstable_batchedUpdates(() => {
          setIsFetching(true);
          setPagination(prev => ({
            limit: prev.limit + 100,
            offset: prev.offset + 100,
          }))
        })
      }
    };
    filtersRef.current?.addEventListener("scroll", handleScroll);

    return () => {
      filtersRef.current?.removeEventListener("scroll", handleScroll);
    };
  }, [isFetching, filtersRef.current]);
  
  useEffect(() => {
    if (isFetching) {
      onLoadMore(pagination.limit, pagination.offset);
      setIsFetching(false)
    }
  }, [isFetching]);

  return (
    <ItemsContainer ref={filtersRef}>
      <Stack
        horizontal={false}
        tokens={{ childrenGap: 10 }}
      >
        {filtersList.filter((filter: any) => (filter.value ?? '').toString()?.includes(searchValue)).map((el) => (
          <Checkbox
            key={el.key}
            label={el.value}
            checked={
              isAllSelected ||
              selectedValues.indexOf(el.key) >= 0
            }
            onChange={(ev, vl) =>
              onElementChecked(el.data, vl)
            }
            styles={{ checkbox: isAllSelected || selectedValues.indexOf(el.key) >= 0 ? {background: `${theme.colors.themePrimary}!important`, borderColor: `${theme.colors.themePrimary}!important`} : {}  }}
          />
        ))}
      </Stack>
    </ItemsContainer>
  );
};

export default FiltersList;